import { NavLink, useLocation } from 'react-router-dom'

const ACCOUNT_NAV_TABS = [
  { id: 'heads', label: 'A/c Head', path: '/masters/acheads/heads/list' },
  { id: 'ac-groups', label: 'A/c Group', path: '/masters/ac-groups/list' },
  { id: 'vendors', label: 'Vendors', path: '/masters/acheads/vendors/list' },
  { id: 'banks', label: 'Banks', path: '/masters/acheads/banks/list' },
  { id: 'employees', label: 'Employees', path: '/masters/acheads/employees/list' },
  { id: 'customers', label: 'Customers', path: '/masters/acheads/customers/list' },
  { id: 'cust-cash', label: 'Cust-Cash', path: '/masters/acheads/cust-cash/list' },
  { id: 'customergroup', label: 'Customer Group', path: '/masters/customergroup/list' },
]

export default function AccountsSubNav() {
  const location = useLocation()

  function isTabActive(tab) {
    if (tab.id === 'heads') {
      return location.pathname.includes('/acheads/heads') || location.pathname === '/masters/acheads/list'
    }
    if (tab.id === 'ac-groups') {
      return location.pathname.includes('/ac-groups')
    }
    if (tab.id === 'customergroup') {
      return location.pathname.includes('/customergroup') || (location.pathname.includes('/groups') && !location.pathname.includes('ac-groups'))
    }
    return location.pathname.includes(`/acheads/${tab.id}`)
  }

  return (
    <nav
      className="flex max-w-full shrink-0 items-center gap-1.5 overflow-x-auto rounded-2xl bg-surface-container-low p-1.5 app-hide-scrollbar"
      aria-label="Accounts Navigation Tabs"
    >
      {ACCOUNT_NAV_TABS.map((tab) => {
        const active = isTabActive(tab)
        return (
          <NavLink
            key={tab.id}
            to={tab.path}
            className={`whitespace-nowrap rounded-xl px-4 py-2 text-xs font-bold transition-all ${
              active
                ? 'bg-surface-container-lowest text-primary shadow-sm ring-1 ring-primary/10'
                : 'text-on-surface-variant hover:bg-surface-container-high/60 hover:text-on-surface'
            }`}
          >
            <span>{tab.label}</span>
          </NavLink>
        )
      })}
    </nav>
  )
}

